/**
 * Socrative Title Tooltip - A small tooltip designed as a replacement for the sluggish and inflexible tooltips generated by the HTML "title" attribute.
 *
 * A title tooltip is composed of the following visual elements:
 *
 *     - A small rectangle with slightly rounded borders
 *     - A text label, centered in the rectangle, for displaying text
 *     - An arrow attached to the top or bottom of the rectangle, used to point at the element associated with the tooltip
 *
 * Properties:
 *
 *     className {string} The CSS class applied to the entire component (usually for positioning)
 *     location  {string} The location for the tooltip. Must be either 'above' or 'below' (defaults to 'above').
 *     text      {string} The text displayed by the component.
 */

import * as React from 'react';

let e = React.createElement;

export default class TitleTooltip extends React.Component {
  render() {
    let className = 'title-tooltip-default',
      location = this.props.location || 'above';

    className += ` title-tooltip-default-${location}`;

    if (this.props.className) {
      className += ` ${this.props.className}`;
    }

    return e('div', {
      className: className,
      children: [
        e('span', {
          className: 'title-tooltip-text-default',
          children: this.props.text,
        }),
        e('div', {
          className: `title-tooltip-arrow title-tooltip-arrow-${location}`,
        }),
      ],
    });
  }
}
